import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Grid from '@material-ui/core/Grid';
import { gsap, Power1 } from 'gsap';
import { Typography, Box } from '@material-ui/core';
import htmlParse from 'react-html-parser';
import AppContext from '../../contexts/AppContext';
import About from '../UI/About';
import HomeButton from '../UI/components/HomeButton';
import IconButton from '@material-ui/core/IconButton';
import './EditLayer.css';
import './HomeLayer.css';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import selectedJson from '../../data/selected.json';

const styles = (theme) => ({
  gridList: {
    padding: theme.spacing(2),
    paddingTop: '30px',
    margin: '0px !important',
  },

  headerGrid: {
    marginBottom: theme.spacing(2),
  },
  title: {
    color: 'black',
  },
  subtitle: {
    color: 'black',
  },
  titleBar: {
    background: 'white',
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  avatar: {
    margin: 10,
    width: 200,
    height: 200,
  },
  margin: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(2),
  },

  locationLink: {
    color: 'white',
  },
  backButton: {
    marginLeft: '0px',
    marginRight: '0px',
    width: '28px',
    minWidth: '28px',
    height: '24px',
    minHeight: '24px',
  },
});

class HomeLayer extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.leftCol = null;
    this.closeBtn = null;
    this.locationsManager = props.locManager;

    this.transitionDuration = 0.5;
    this.pickLocationRef = React.createRef();

    this.gridData = [];

    this.state = {
      step: 'pick-location',
      mode: props.mode,
      showList: false,
      selectedCity: null,
    };
  }

  componentDidMount() {
    if (this.leftCol)
      gsap.to(this.leftCol, { left: 0, duration: this.transitionDuration });
    if (this.closeBtn) {
      gsap.to(this.closeBtn, {
        opacity: 1,
        duration: 0.5,
        delay: this.transitionDuration,
      });
    }
    this.setFromLocation();
  }

  componentDidUpdate(prevProps) {
    if (this.props.mode !== prevProps.mode) {
      this.gridData = [];

      if (this.props.mode === 'about') {
        this.aboutHandler(false);
      }
    }

    if (this.state.showList) {
      gsap.to('.pick-location-list', {
        x: 0.5,
        ease: Power1.easeInOut,
        duration: 0,
      });
    }

    /*
    if (this.props.location !== prevProps.location) {
      this.setFromLocation();
    }
    */
    if (this.closeBtn != null) {
      gsap.to(this.closeBtn, {
        opacity: 1,
        duration: 0.5,
        delay: this.transitionDuration,
      });
    }
  }

  sendTrackEvent(action, label, value) {
    if (this.context.axl) {
      const AxL = require('../../utils/Axl').default;

      this.context.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action,
        label,
        value,
      });
    }
  }

  setFromLocation() {
    if (this.props.mode === 'about') {
      this.aboutHandler(false);
    }

    /*
    if (this.props.location.pathname === '/create-artwork') {
      this.createArtworkHandler(false);
    }
    if (this.props.location.pathname === '/inspire-me') {
      this.inspireMeHandler(false);
    }
    if (this.props.location.pathname === '/about') {
      this.aboutHandler(false);
    }
    if (this.props.location.pathname === '/') {
      this.setState({
        showList: false,
      });
    }
    */
  }

  onClickHandler(item) {
    this.gridData = [];

    if (this.state.mode === 'create-artwork') {
      if (this.state.selectedCity) {
        this.props.onCityClickHandler(item);
        this.sendTrackEvent('view-location', item.name);
      } else {
        this.sendTrackEvent('view-location', item.city);
      }
    }

    if (this.state.mode === 'inspire-me') {
      this.props.onLocationClickHandler(item);
      this.setState({ showList: false });
      this.sendTrackEvent('view-inspire', item.id);
    }
  }

  aboutHandler(updateRoute = true) {
    this.setState(
      {
        mode: 'about',
        selectedCity: null,
        showList: true,
      },
      () => {
        if (updateRoute) this.props.onStateChange(this.state.mode);
      },
    );
  }

  createArtworkHandler(updateRoute = true) {
    this.gridData = [];
    this.setState(
      {
        mode: 'create-artwork',
        selectedCity: null,
        showList: true,
      },
      () => {
        if (updateRoute) this.props.onStateChange(this.state.mode);
      },
    );
  }

  inspireMeHandler(updateRoute = true) {
    this.gridData = [];
    this.setState(
      {
        mode: 'inspire-me',
        selectedCity: null,
        showList: true,
      },
      () => {
        if (updateRoute) this.props.onStateChange(this.state.mode);
      },
    );
  }

  render() {
    const { classes } = this.props;
    const { dictionnary } = this.context;

    this.gridData = [];
    let headerContent = null;
    if (this.state.mode === 'create-artwork') {
      if (this.state.selectedCity == null) {
        this.gridData = this.locationsManager.getCities();
        headerContent = (
          <>
            &nbsp;
            {dictionnary.get('home-create-gallery-menu')}
          </>
        );
      } else {
        this.gridData = this.locationsManager.getByCity(
          this.state.selectedCity.city,
        );
        headerContent = (
          <>
            <Button
              classes={{ root: classes.backButton }}
              size="small"
              onClick={() => {
                this.setState({
                  mode: 'create-artwork',
                  selectedCity: null,
                });
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </Button>
            &nbsp;
            {dictionnary.get('home-create-gallery-menu-location-youare')}
            {this.state.selectedCity.title ||
              this.state.selectedCity.name} –{' '}
            {dictionnary.get('home-create-gallery-menu-location')}
          </>
        );
      }
    } else if (this.state.mode === 'inspire-me') {
      headerContent = <>&nbsp;{dictionnary.get('home-location-list-menu')}</>;
      this.gridData = JSON.parse(JSON.stringify(selectedJson));
    }

    let descrContent = [];
    if (this.state.mode === 'about') {
      headerContent = (
        <>
          <Button
            classes={{ root: classes.backButton }}
            size="small"
            onClick={() => {
              this.setState(
                {
                  mode: '',
                  selectedCity: null,
                  showList: false,
                },
                () => {
                  this.props.onBackButtonHandler();
                },
              );
            }}
          >
            <NavigateBeforeIcon fontSize="small" />
          </Button>
        </>
      );
      descrContent = <About dictionnary={dictionnary}></About>;
    }

    const { currentLocation, loadedGallery, onToggleArtworks } = this.props;

    return (
      <>
        {this.state.step === 'pick-location' && (
          <div className="front-layer-container">
            <Grid container spacing={0} className={''}>
              {this.props.showBackButton && !this.state.showList && (
                <>
                  <div
                    ref={(c) => (this.closeBtn = c)}
                    className={'home-close-btn'}
                  >
                    <IconButton
                      aria-label="close"
                      className={'home-back-icon'}
                      onClick={() => {
                        this.props.onBackButtonHandler();
                      }}
                    >
                      <NavigateBeforeIcon fontSize="large" />
                    </IconButton>
                  </div>
                </>
              )}

              {true && (
                <Grid item xs={3}>
                  <div
                    ref={(c) => (this.leftCol = c)}
                    className="pick-location-left"
                  >
                    <div id="header-left"></div>
                    <div className={'home-subtitle'}>
                      <Typography variant="body1">
                        {htmlParse(dictionnary.get('home-descr'))}
                      </Typography>
                    </div>
                    <Box display="flex" className="home-credits-container">
                      <div className={'home-descr'}>
                        <Typography variant="subtitle2">
                          {htmlParse(dictionnary.get('home-subtitle'))}
                        </Typography>
                      </div>
                      <div className={'home-logo-un'}>
                        <img
                          alt={'logo-UN'}
                          id={'logo-un'}
                          src={'street-gallery/assets/icons/UN75_blue_E.jpg'}
                        ></img>
                      </div>
                    </Box>

                    <div>
                      <HomeButton
                        active={
                          this.state.showList &&
                          this.state.mode === 'create-artwork'
                        }
                        onClickHandler={() => {
                          this.createArtworkHandler();
                        }}
                        hoverBackgroundColor={'#5bd7e5'}
                        title={dictionnary.get(
                          'home-create-gallery-menu-location',
                        )}
                        subtitle={dictionnary.get(
                          'home-create-gallery-menu-location-descr',
                        )}
                      ></HomeButton>
                      <HomeButton
                        hoverBackgroundColor={'#5b92e5'}
                        active={
                          this.state.showList &&
                          this.state.mode === 'inspire-me'
                        }
                        onClickHandler={() => {
                          this.inspireMeHandler();
                        }}
                        title={dictionnary.get('home-location-list')}
                        subtitle={dictionnary.get('home-location-list-descr')}
                      ></HomeButton>
                    </div>

                    <div id="logos">
                      <div>
                        <img
                          alt={'logo-un'}
                          id="home-logo"
                          src={'street-gallery/assets/icons/UN75_blue_E.jpg'}
                        ></img>
                        <img
                          alt={'logo-gac'}
                          id="home-gac-logo"
                          src={
                            'street-gallery/assets/icons/logo_lockup_arts___culture_icon_vertical.svg'
                          }
                        ></img>
                      </div>
                    </div>
                  </div>
                </Grid>
              )}
              {this.state.showList && (
                <Grid
                  item
                  xs={8}
                  className="pick-location-list"
                  ref={this.pickLocationRef}
                >
                  <div className={classes.gridList}>
                    <Typography
                      className={classes.headerGrid}
                      variant="h6"
                      component="h6"
                    >
                      {headerContent}
                    </Typography>
                    {descrContent}
                    <GridList
                      cellHeight={
                        this.state.mode === 'inspire-me'
                          ? this.gridData.length <= 4
                            ? 320
                            : 250
                          : this.gridData.length > 4
                          ? 250
                          : 320
                      }
                      spacing={20}
                      cols={
                        this.state.mode === 'inspire-me'
                          ? this.gridData.length <= 4
                            ? 2
                            : 3
                          : this.gridData.length > 4
                          ? 5
                          : 2
                      }
                    >
                      {this.gridData.map((item, index) => (
                        <GridListTile
                          onClick={() => {
                            this.onClickHandler(item);
                            this.setState({
                              showList: true,
                              selectedCity: item,
                            });
                          }}
                          key={item.img + index}
                          className="grid-list-tile active"
                        >
                          <img
                            className="location-img"
                            src={item.img}
                            alt={item.title || item.name}
                          />
                          <GridListTileBar
                            title={htmlParse(item.title || item.name)}
                            subtitle={<span>{htmlParse(item.subtitle)}</span>}
                            classes={{
                              root: classes.titleBar,
                              title: classes.title,
                              subtitle: classes.subtitle,
                            }}
                          />
                        </GridListTile>
                      ))}
                    </GridList>
                  </div>
                </Grid>
              )}
              {this.state.showList && (
                <>
                  <div
                    ref={(c) => (this.closeBtn = c)}
                    className={'home-close-btn-scnd'}
                  >
                    <IconButton
                      aria-label="close"
                      size="small"
                      className={'home-back-icon'}
                      onClick={() => {
                        if (this.props.showBackButton) {
                          this.props.onBackButtonHandler();
                        } else {
                          this.setState({ showList: false });
                        }
                      }}
                    >
                      <NavigateBeforeIcon fontSize="large" />
                    </IconButton>
                  </div>
                </>
              )}
            </Grid>
          </div>
        )}

        <div id={'container-details-flex'}>
          {loadedGallery && currentLocation && !this.state.showList && (
            <>
              <div id={'container-details'}>
                <Typography>
                  {loadedGallery && this.props.loadedGallery.meta && (
                    <>
                      <span>
                        <b> {this.props.loadedGallery.meta.theme}</b>
                        {' – ' +
                          currentLocation.city +
                          ', ' +
                          currentLocation.name}
                      </span>
                      <br />
                    </>
                  )}
                  {!loadedGallery ||
                    (!this.props.loadedGallery.meta && (
                      <>
                        <div id="container-details-link">
                          {currentLocation.city}, {currentLocation.name}
                        </div>
                      </>
                    ))}
                </Typography>
              </div>
              <div
                id={'container-details-artworks'}
                onClick={() => {
                  onToggleArtworks();
                }}
              >
                {dictionnary.get('common-artworks-in')}
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

export default withRouter(withStyles(styles)(HomeLayer));
